import FieldPayerName from './FieldPayerName';
export default FieldPayerName;
